import type { HomepageContent } from '../../cms/homepage'
import HomepageActionLink from './HomepageActionLink'
import HomepageSectionHeader from './HomepageSectionHeader'

type StartJourneySectionProps = {
  content: HomepageContent['startJourney']
}

export default function StartJourneySection({
  content,
}: StartJourneySectionProps) {
  return (
    <section className="home-section">
      <HomepageSectionHeader title={content.title} intro={content.intro} />
      <div className="home-path-grid">
        {content.cards.map((card, index) => (
          <HomepageActionLink
            key={card.title}
            className={`home-path-card home-path-card-${index + 1}`}
            href={card.href}
          >
            <span className="home-path-card-tone" aria-hidden="true" />
            <h3>{card.title}</h3>
            <p>{card.body}</p>
            <span className="home-path-card-cta">{card.ctaLabel}</span>
          </HomepageActionLink>
        ))}
      </div>
    </section>
  )
}

